import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
)




const AttendanceDoughnutChart = ({hoursSpent}) => {
    const data = {
        labels: [
            'Today',
            'This Week',
            'This Month'
        ],
        datasets: [{
            label: 'Hours Spent',
            data: hoursSpent,
            backgroundColor: [
                'rgb(54, 162, 235)',
                'rgb(255, 99, 132)',
                'rgb(255, 205, 86)',
            ],
            hoverOffset: 4
        }]
    };
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
    };
  return (
    <div className="attendance__body-report_chart-box">
        <div style={{height: '200px'}}>
            <Doughnut data={data} options={options}/>
        </div>
        <div className="attendance__body-report_chart-legend">
            <span>Today</span>
            <span>This Week</span>
            <span>This Month</span>
        </div>
    </div>
  )
}

export default AttendanceDoughnutChart